var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,13h2v6l-1,1H2l-1-1V4l1-1H6v2H3v13H21v-5Zm-1.29-11.71l-1.41,1.41,2.29,2.29H12l-.71,.29-4,4-.29,.71v4h2v-3.59l3.41-3.41h8.17l-2.29,2.29,1.41,1.41,4.29-4.29v-.83L19.71,1.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/1787897133/media/icon-share.8c04f1f1bfad7e801f6678f71f3f25dc.svg";
export { ForwardRef as ReactComponent };